module.exports = __webpack_public_path__ + "img/IOT.c080ef99.png";